import React from 'react';

import { AppleWalletDesktopButton } from 'src/components/loyalty/loyalty-pass/apple-wallet-button';
import { useLoyaltyPassModal } from 'src/components/modals/loyalty-pass';
import { LoyaltyPassBarcode } from 'src/assets/loyalty-pass/loyalty-pass-barcode';
import { DesktopContainer, SVGWrapper, TextContent, Title, Description } from '../styles';

type AddToWalletDesktopProps = {
  url: string;
  title: string;
  description: string;
};

export const AddToWalletDesktop: React.FC<AddToWalletDesktopProps> = ({ url, title, description }): JSX.Element => {
  const { open } = useLoyaltyPassModal();

  const handleClick = (): void => {
    void open({ url });
  };

  return (
    <DesktopContainer>
      <SVGWrapper>
        <LoyaltyPassBarcode />
      </SVGWrapper>
      <TextContent>
        <Title size='xlarge' tag='h4' weight='bold' lineHeight='1.2'>
          {title}
        </Title>
        <Description size='small' tag='p' weight='regular' lineHeight='18px'>
          {description}
        </Description>
      </TextContent>
      <AppleWalletDesktopButton onClick={handleClick} />
    </DesktopContainer>
  );
};
